export default __webpack_public_path__ + "static/media/icon_texto_selected.a2c2e981.svg";